module.exports = __webpack_public_path__ + "static/img/topright_1.ad07e0a.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/topright_1.png
// module id = 5gd4
// module chunks = 1